import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-dialogo-confirmacion',
  templateUrl: './dialogo-confirmacion.component.html',
  styleUrls: ['./dialogo-confirmacion.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DialogoConfirmacionComponent implements OnInit {
  // Número entero opcional que determina el ancho del botón Sí
  // >1 para que el botón Sí sea más grande
  // 0-1 o null para que los botones sean del mismo tamaño

  constructor(public dialogRef: MatDialogRef<DialogoConfirmacionComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.validarNumero();


  }

  private validarNumero() {
    if (typeof this.data.okSize == "number") {
      this.data.okSize = this.data.okSize ? parseInt(this.data.okSize.toString()) : 1;
    } else {
      this.data.okSize = 1;
    }
    if (typeof this.data.okSize != "number") {
      this.data.okSize = 1;
    }
    if (this.data.okSize < 1) {
      this.data.okSize = 1;
    }

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  onSiClick(): void {
    this.dialogRef.close(true);
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/table-items/dialogo-confirmacion/dialogo-confirmacion.component.ts